// 设备信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

const MAP = {
  0: i18n.gettext('不需要'),
  1: i18n.gettext('需要')
}

function formatPadInfo (type) {
  return MAP[type] || i18n.gettext('暂无')
}

export default (state) => {
  let contractInfo = get(state, 'currentShopBaseDetail', {})
  return {
    title: i18n.gettext('设备信息'),
    content: [
      {
        title: i18n.gettext('Pad'),
        label: contractInfo.deviceFlagbinNeedPad ? formatPadInfo(contractInfo.deviceFlagbinNeedPad) : contractInfo.deviceFlagbinNeedPad
      }
    ]
  }
}
